import React from "react";
// nodejs library that concatenates classes
import classNames from "classnames";

// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import ListItem from '@material-ui/core/ListItem';
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";

// @material-ui/icons
import NewReleasesIcon from '@material-ui/icons/NewReleases';
import CheckCircle from '@material-ui/icons/CheckCircle';

// core components
import Header from "components/Header/Header.js";
import Footer from "components/Footer/Footer.js";
import HeaderLinks from "components/Header/HeaderLinks.js";

import styles from "assets/jss/material-kit-react/views/staticPages.js";
import Parallax from "components/Parallax/Parallax";
import TaximeterMock from "../assets/img/taximeter-mockup.png";
import FacialMock from "../assets/img/facial-recognition-mockup.png";
import BockLaterMock from "../assets/img/book-later-mockup.png";
const dashboardRoutes = [];

const useStyles = makeStyles(styles);

export default function Features(props) {
  const classes = useStyles();
  const { ...rest } = props;
  return (
    <div>
      <Header
        color="transparent"
        routes={dashboardRoutes}
        rightLinks={<HeaderLinks />}
        fixed
        changeColorOnScroll={{
          height: 400,
          color: "white"
        }}
        {...rest}
      />
      <Parallax small filter image={require("assets/img/header-back.jpg")} />
      <div className={classNames(classes.main, classes.mainRaised)}>
 
        <div className={classes.container}>
            <br/>
            <div style={{display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent:'center' }}>
              <NewReleasesIcon style={{ color: '#ffd700', fontSize: 70 }}/>
              <h2 className={classes.title}>  Novidades</h2>
              
            </div>
            <br/>
            
            <div style={{display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent:'center' }}>
              <h3 className={classes.title} style={{ display:'flex', marginLeft:'auto', marginRight:'auto'}}>Taxímetro</h3>
            </div>
            <div style={{display: 'flex', flexDirection: 'row', justifyContent: 'center'}}>
              <img src={TaximeterMock} style={{backgroundSize: 'cover', width: '50%', marginLeft: 0, marginRight: 'auto'}} />
              <div style={{display: 'flex', flexDirection: 'column'}}>
                <ListItem>
                  <ListItemIcon>
                    <CheckCircle style={{ color: '#48A54B' }} />
                  </ListItemIcon>
                  <ListItemText primary='Agilidade na utilização' style={{ color: '#616A8F' }} />
                </ListItem>
                <ListItem>
                  <ListItemIcon>
                    <CheckCircle style={{ color: '#48A54B' }} />
                  </ListItemIcon>
                  <ListItemText primary='Precisão e qualidade da Tac' style={{ color: '#616A8F' }} />
                </ListItem>
                <ListItem>
                  <ListItemIcon>
                    <CheckCircle style={{ color: '#48A54B' }} />
                  </ListItemIcon>
                  <ListItemText primary='Mapa para referência' style={{ color: '#616A8F' }} />
                </ListItem>
              </div>
            </div>
            <br/>
            <div style={{display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent:'center' }}>
              <h3 className={classes.title} style={{ display:'flex', marginLeft:'auto', marginRight:'auto'}}>Reconhecimento Facial</h3>
            </div>
            <GridContainer spacing={3}>
            <GridItem xs>
            <div style={{display: 'flex', flexDirection: 'row', justifyContent: 'center'}}>
              <img src={FacialMock} style={{backgroundSize: 'cover', width: '50%'}} />
              <div style={{display: 'flex', flexDirection: 'column'}}>
                <ListItem>
                  <ListItemIcon>
                    <CheckCircle style={{ color: '#48A54B' }} />
                  </ListItemIcon>
                  <ListItemText primary='Segurança de ponta para você' style={{ color: '#616A8F' }} />
                </ListItem>
                <ListItem>
                  <ListItemIcon>
                    <CheckCircle style={{ color: '#48A54B' }} />
                  </ListItemIcon>
                  <ListItemText primary='Tecnologia avançada fornecida pela Microsoft, referência em reconhecimento facial' style={{ color: '#616A8F' }} />
                </ListItem>
                <ListItem>
                  <ListItemIcon>
                    <CheckCircle style={{ color: '#48A54B' }} />
                  </ListItemIcon>
                  <ListItemText primary='Sem custo adicional' style={{ color: '#616A8F' }} />
                </ListItem>
              </div>
            </div>
          </GridItem>
          </GridContainer>
          <br/>
          <div style={{display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent:'center' }}>
            <h3 className={classes.title} style={{ display:'flex', marginLeft:'auto', marginRight:'auto'}}>Agendamento de Viagem</h3>
          </div>
          <GridContainer spacing={3}>
            <GridItem xs>
            <div style={{display: 'flex', flexDirection: 'row', justifyContent: 'center'}}>
              <img src={BockLaterMock} style={{backgroundSize: 'cover', width: '50%'}} />
              <div style={{display: 'flex', flexDirection: 'column'}}>
                <ListItem>
                  <ListItemIcon>
                    <CheckCircle style={{ color: '#48A54B' }} />
                  </ListItemIcon>
                  <ListItemText primary='Agende uma corrida com antecedência' style={{ color: '#616A8F' }} />
                </ListItem>
                <ListItem>
                  <ListItemIcon>
                    <CheckCircle style={{ color: '#48A54B' }} />
                  </ListItemIcon>
                  <ListItemText primary='Nossos Motoristas são notificados 15 minutos antes, tenha certeza que será lembrado!' style={{ color: '#616A8F' }} />
                </ListItem>
                <ListItem>
                  <ListItemIcon>
                    <CheckCircle style={{ color: '#48A54B' }} />
                  </ListItemIcon>
                  <ListItemText primary='Sem custo adicional na corrida' style={{ color: '#616A8F' }} />
                </ListItem>
              </div>
            </div>
          </GridItem>
          </GridContainer>
        </div>
        </div>

      <Footer />
    </div>
  );
}
